import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AppLayout } from "@/components/AppLayout.jsx";
import { HomePage, AboutPage } from "@/pages/public/HomeAboutPages.jsx";
import { DojosPage, StudentsPage } from "@/pages/public/DirectoryPages.jsx";
import { PublicInstructorsR0Page } from "@/pages/r0/PublicInstructorsR0Page.jsx";
import { PublicInstructorDetailR0Page } from "@/pages/r0/PublicInstructorDetailR0Page.jsx";
import { DojoDetailPage } from "@/pages/public/DojoDetailPage.jsx";
import { DocumentsPublicPage, ProtocolsPage } from "@/pages/public/DocumentsProtocolsPages.jsx";
import {
  LoginPage,
  AccountRequestPage,
  MonEspacePage,
  MesInformationsPage,
  MonDojoPage,
  MesDocumentsPage,
  AidePage,
  FormationPage,
  MonSenseiPage,
  SenseiDashboardPage,
  SenseiStudentsPage,
  SenseiDocumentsPage,
  SenseiCorrectionsPage,
} from "@/pages/connected/ConnectedPages.jsx";
import {
  AdminDashboardPage,
  AdminAccountsPage,
  AdminOfficialListPrepPage,
  AdminRolesPage,
  AdminRequestsPage,
  AdminDojosPage,
  AdminStudentsPage,
  AdminDocumentsPage,
  AdminImportPage,
  AdminOrganisationPage,
  AdminParentsPage,
} from "@/pages/admin/AdminPages.jsx";
import { AdminAvatarDiagnosticPage } from "@/pages/admin/AdminAvatarDiagnosticPage.jsx";
import {
  AdminOrganisationHubPage,
  AdminActivitesHubPage,
  AdminProgressionHubPage,
  AdminAdministrationHubPage,
} from "@/pages/admin/AdminNavHubPages.jsx";
import { AdminAssistantsPage, AdminCommunicationsPage } from "@/pages/dojoos/DojoOsPlaceholderPages.jsx";
import {
  AdminClassesPage,
  AdminEventsPage,
  AdminAttendancePage,
  SenseiClassesPage,
  SenseiEventsPage,
  SenseiAttendancePage,
  SempaiClassesPage,
  SempaiEventsPage,
  SempaiAttendancePage,
  MesCoursPage,
  MesEvenementsPage,
  ParentSchedulePage,
  ParentEventsPage,
} from "@/pages/schedule/SchedulePages.jsx";
import {
  AdminBeltsPage,
  AdminProgressionPage,
  AdminExamensPage,
  SenseiProgressionPage,
  SenseiExamensPage,
  SenseiBeltsPage,
  SempaiProgressionPage,
  SempaiBeltsPage,
  MaProgressionPage,
  ParentProgressPage,
} from "@/pages/progress/ProgressPages.jsx";
import {
  AdminTitlesPage,
  AdminTitleApplicationsPage,
  AdminRecognitionsPage,
  AdminTitleAuthorityPage,
  SenseiTitlesPage,
  SenseiTitleApplicationsPage,
  SempaiTitlesPage,
  MesTitresPage,
} from "@/pages/titles/TitleRecognitionPages.jsx";
import {
  AdminAuthorityDocumentsPage,
  AdminEvidenceDossiersPage,
  AdminValidationLogPage,
  SenseiTitleDocumentsPage,
  SempaiTitleDocumentsPage,
} from "@/pages/authority/AuthorityDocumentsPages.jsx";
import {
  SempaiDashboardPage,
  SempaiStudentsPage,
  SempaiDocumentsPage,
  ParentDashboardPage,
  ParentChildrenPage,
  ParentCommunicationsPage,
  ParentDocumentsPage,
} from "@/pages/rolespaces/RoleSpacePages.jsx";
import {
  ShotokanBlackDragonAdminLayout,
  ShotokanBlackDragonSenseiLayout,
  ShotokanBlackDragonSempaiLayout,
} from "@/pages/shotokanBlackDragon/ShotokanBlackDragonLayouts.jsx";
import {
  ShotokanBlackDragonAdminDashboard,
  ShotokanBlackDragonSenseiDashboard,
  ShotokanBlackDragonSempaiDashboard,
} from "@/pages/shotokanBlackDragon/ShotokanBlackDragonDashboard.jsx";
import { DocumentsPreuvesAdminLayout } from "@/pages/documentsPreuves/DocumentsPreuvesLayout.jsx";
import { DocumentsPreuvesDashboard } from "@/pages/documentsPreuves/DocumentsPreuvesDashboard.jsx";
import { DocumentsPreuvesDocumentsPage } from "@/pages/documentsPreuves/DocumentsPreuvesDocumentsPage.jsx";
import { DocumentsPreuvesDossiersPage } from "@/pages/documentsPreuves/DocumentsPreuvesDossiersPage.jsx";
import { DocumentsPreuvesValidationPage } from "@/pages/documentsPreuves/DocumentsPreuvesValidationPage.jsx";
import { DocumentsPreuvesJournalPage } from "@/pages/documentsPreuves/DocumentsPreuvesJournalPage.jsx";
import { DocumentsPreuvesImportPage } from "@/pages/documentsPreuves/DocumentsPreuvesImportPage.jsx";
import { DocumentsPreuvesSecuritePage } from "@/pages/documentsPreuves/DocumentsPreuvesSecuritePage.jsx";
import { DocumentsPreuvesShotokanNestedLayout } from "@/pages/documentsPreuves/DocumentsPreuvesShotokanNestedLayout.jsx";
import { InteractivePresentationPage } from "@/pages/admin/InteractivePresentationPage.jsx";
import { PrivacyPolicyPage, ContactPage } from "@/pages/public/CompliancePublicPages.jsx";
import { ChangePasswordPage } from "@/pages/connected/ChangePasswordPage.jsx";
import { WelcomeHomePage } from "@/pages/connected/WelcomeHomePage.jsx";
import { PasswordChangeGuard } from "@/components/PasswordChangeGuard.jsx";
import { HanshiInstructorsR0Page } from "@/pages/r0/HanshiInstructorsR0Page.jsx";
import { HanshiMembersR0Page } from "@/pages/r0/HanshiMembersR0Page.jsx";
import { SenseiMembersR0Page } from "@/pages/r0/SenseiMembersR0Page.jsx";
import { LaunchCockpitPage } from "@/pages/admin/LaunchCockpitPage.jsx";
import { BecomeMemberWizardPage } from "@/pages/membership/BecomeMemberWizardPage.jsx";
import { PublicCalendarPage, PublicBlackDragonPage } from "@/pages/membership/PublicMembershipPages.jsx";
import {
  MemberCalendarPage,
  MemberAdhesionPage,
  MemberExamsPage,
  MemberBlackDragonPage,
  ParentAdhesionPage,
} from "@/pages/membership/MemberPortalMembershipPages.jsx";
import {
  AdminMembershipCockpitPage,
  AdminMember360Page,
  AdminBlackDragonCockpitPage,
} from "@/pages/membership/AdminMembershipPages.jsx";
import { AdminOfficialMembersPage } from "@/pages/membership/AdminOfficialMembersPage.jsx";

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="changer-mot-de-passe" element={<ChangePasswordPage />} />
        <Route element={<PasswordChangeGuard />}>
        <Route index element={<HomePage />} />
        <Route path="a-propos" element={<AboutPage />} />
        <Route path="dojos" element={<DojosPage />} />
        <Route path="dojos/:id" element={<DojoDetailPage />} />
        <Route path="instructeurs" element={<PublicInstructorsR0Page />} />
        <Route path="instructeurs/:id" element={<PublicInstructorDetailR0Page />} />
        <Route path="etudiants" element={<StudentsPage />} />
        <Route path="documents" element={<DocumentsPublicPage />} />
        <Route path="protocoles" element={<ProtocolsPage />} />
        <Route path="confidentialite" element={<PrivacyPolicyPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="connexion" element={<LoginPage />} />
        <Route path="demande-compte" element={<AccountRequestPage />} />
        <Route path="devenir-membre" element={<BecomeMemberWizardPage />} />
        <Route path="calendrier" element={<PublicCalendarPage />} />
        <Route path="black-dragon" element={<PublicBlackDragonPage />} />
        <Route path="accueil" element={<WelcomeHomePage />} />
        <Route path="mon-espace" element={<MonEspacePage />} />
        <Route path="mes-informations" element={<MesInformationsPage />} />
        <Route path="mon-dojo" element={<MonDojoPage />} />
        <Route path="mes-documents" element={<MesDocumentsPage />} />
        <Route path="mes-cours" element={<MesCoursPage />} />
        <Route path="mes-evenements" element={<MesEvenementsPage />} />
        <Route path="mon-sensei" element={<MonSenseiPage />} />
        <Route path="ma-progression" element={<MaProgressionPage />} />
        <Route path="mes-examens" element={<MemberExamsPage />} />
        <Route path="mon-calendrier" element={<MemberCalendarPage />} />
        <Route path="mon-adhesion" element={<MemberAdhesionPage />} />
        <Route path="espace-black-dragon" element={<MemberBlackDragonPage />} />
        <Route path="mes-titres" element={<MesTitresPage />} />
        <Route path="sensei" element={<SenseiDashboardPage />} />
        <Route path="sensei/mon-dojo" element={<MonDojoPage />} />
        <Route path="sensei/etudiants" element={<SenseiMembersR0Page />} />
        <Route path="sensei/mes-etudiants" element={<Navigate to="/sensei/etudiants" replace />} />
        <Route path="sensei/classes" element={<SenseiClassesPage />} />
        <Route path="sensei/evenements" element={<SenseiEventsPage />} />
        <Route path="sensei/presences" element={<SenseiAttendancePage />} />
        <Route path="sensei/progression" element={<SenseiProgressionPage />} />
        <Route path="sensei/examens" element={<SenseiExamensPage />} />
        <Route path="sensei/ceintures" element={<SenseiBeltsPage />} />
        <Route path="sensei/shotokan-black-dragon" element={<ShotokanBlackDragonSenseiLayout />}>
          <Route index element={<ShotokanBlackDragonSenseiDashboard />} />
          <Route path="titres" element={<SenseiTitlesPage />} />
          <Route path="demandes" element={<SenseiTitleApplicationsPage />} />
          <Route path="documents" element={<SenseiTitleDocumentsPage />} />
        </Route>
        <Route path="sensei/titres" element={<Navigate to="/sensei/shotokan-black-dragon/titres" replace />} />
        <Route path="sensei/demandes-titres" element={<Navigate to="/sensei/shotokan-black-dragon/demandes" replace />} />
        <Route path="sensei/documents-titres" element={<Navigate to="/sensei/shotokan-black-dragon/documents" replace />} />
        <Route path="sensei/documents" element={<SenseiDocumentsPage />} />
        <Route path="sensei/corrections" element={<SenseiCorrectionsPage />} />
        <Route path="sempai" element={<SempaiDashboardPage />} />
        <Route path="sempai/classes" element={<SempaiClassesPage />} />
        <Route path="sempai/etudiants" element={<SempaiStudentsPage />} />
        <Route path="sempai/evenements" element={<SempaiEventsPage />} />
        <Route path="sempai/presences" element={<SempaiAttendancePage />} />
        <Route path="sempai/progression" element={<SempaiProgressionPage />} />
        <Route path="sempai/ceintures" element={<SempaiBeltsPage />} />
        <Route path="sempai/shotokan-black-dragon" element={<ShotokanBlackDragonSempaiLayout />}>
          <Route index element={<ShotokanBlackDragonSempaiDashboard />} />
          <Route path="parcours" element={<SempaiTitlesPage />} />
          <Route path="documents" element={<SempaiTitleDocumentsPage />} />
        </Route>
        <Route path="sempai/titres" element={<Navigate to="/sempai/shotokan-black-dragon/parcours" replace />} />
        <Route path="sempai/documents-titres" element={<Navigate to="/sempai/shotokan-black-dragon/documents" replace />} />
        <Route path="sempai/documents" element={<SempaiDocumentsPage />} />
        <Route path="parent" element={<ParentDashboardPage />} />
        <Route path="parent/mes-enfants" element={<ParentChildrenPage />} />
        <Route path="parent/horaires" element={<ParentSchedulePage />} />
        <Route path="parent/progression" element={<ParentProgressPage />} />
        <Route path="parent/evenements" element={<ParentEventsPage />} />
        <Route path="parent/communications" element={<ParentCommunicationsPage />} />
        <Route path="parent/documents" element={<ParentDocumentsPage />} />
        <Route path="parent/adhesion" element={<ParentAdhesionPage />} />
        <Route path="aide" element={<AidePage />} />
        <Route path="formation" element={<FormationPage />} />
        <Route path="admin" element={<AdminDashboardPage />} />
        <Route path="admin/lancement-1er-septembre" element={<LaunchCockpitPage />} />
        <Route path="admin/organisation-hub" element={<AdminOrganisationHubPage />} />
        <Route path="admin/activites-hub" element={<AdminActivitesHubPage />} />
        <Route path="admin/progression-hub" element={<AdminProgressionHubPage />} />
        <Route path="admin/administration-hub" element={<AdminAdministrationHubPage />} />
        <Route path="admin/comptes" element={<AdminAccountsPage />} />
        <Route path="admin/diagnostic-avatar" element={<AdminAvatarDiagnosticPage />} />
        <Route path="admin/preparation-liste-officielle" element={<AdminOfficialListPrepPage />} />
        <Route path="admin/roles" element={<AdminRolesPage />} />
        <Route path="admin/demandes" element={<AdminRequestsPage />} />
        <Route path="admin/adhesions" element={<AdminMembershipCockpitPage />} />
        <Route path="admin/adhesions/:id" element={<AdminMember360Page />} />
        <Route path="admin/membres-officiels" element={<AdminOfficialMembersPage />} />
        <Route path="admin/black-dragon-adhesions" element={<AdminBlackDragonCockpitPage />} />
        <Route path="admin/organisation" element={<AdminOrganisationPage />} />
        <Route path="admin/dojos" element={<AdminDojosPage />} />
        <Route path="hanshi/instructeurs" element={<HanshiInstructorsR0Page />} />
        <Route path="hanshi/membres" element={<HanshiMembersR0Page />} />
        <Route path="admin/instructors" element={<Navigate to="/hanshi/instructeurs" replace />} />
        <Route path="admin/instructeurs" element={<Navigate to="/hanshi/instructeurs" replace />} />
        <Route path="admin/etudiants" element={<Navigate to="/hanshi/membres" replace />} />
        <Route path="admin/membres" element={<Navigate to="/hanshi/membres" replace />} />
        <Route path="admin/documents" element={<AdminDocumentsPage />} />
        <Route path="admin/import" element={<AdminImportPage />} />
        <Route path="admin/presentation-interactive" element={<InteractivePresentationPage />} />
        <Route path="admin/assistants" element={<AdminAssistantsPage />} />
        <Route path="admin/parents" element={<AdminParentsPage />} />
        <Route path="admin/classes" element={<AdminClassesPage />} />
        <Route path="admin/evenements" element={<AdminEventsPage />} />
        <Route path="admin/presences" element={<AdminAttendancePage />} />
        <Route path="admin/ceintures" element={<AdminBeltsPage />} />
        <Route path="admin/progression" element={<AdminProgressionPage />} />
        <Route path="admin/examens" element={<AdminExamensPage />} />
        <Route path="admin/documents-preuves" element={<DocumentsPreuvesAdminLayout />}>
          <Route index element={<DocumentsPreuvesDashboard />} />
          <Route path="documents" element={<DocumentsPreuvesDocumentsPage />} />
          <Route path="dossiers" element={<DocumentsPreuvesDossiersPage />} />
          <Route path="validation" element={<DocumentsPreuvesValidationPage />} />
          <Route path="journal" element={<DocumentsPreuvesJournalPage />} />
          <Route path="import" element={<DocumentsPreuvesImportPage />} />
          <Route path="securite" element={<DocumentsPreuvesSecuritePage />} />
        </Route>
        <Route path="admin/shotokan-black-dragon" element={<ShotokanBlackDragonAdminLayout />}>
          <Route index element={<ShotokanBlackDragonAdminDashboard />} />
          <Route path="titres" element={<AdminTitlesPage />} />
          <Route path="demandes" element={<AdminTitleApplicationsPage />} />
          <Route path="reconnaissances" element={<AdminRecognitionsPage />} />
          <Route path="autorite" element={<AdminTitleAuthorityPage />} />
          <Route path="documents-preuves" element={<DocumentsPreuvesShotokanNestedLayout />}>
            <Route index element={<DocumentsPreuvesDashboard />} />
            <Route path="documents" element={<DocumentsPreuvesDocumentsPage />} />
            <Route path="dossiers" element={<DocumentsPreuvesDossiersPage />} />
            <Route path="validation" element={<DocumentsPreuvesValidationPage />} />
            <Route path="journal" element={<DocumentsPreuvesJournalPage />} />
            <Route path="import" element={<DocumentsPreuvesImportPage />} />
            <Route path="securite" element={<DocumentsPreuvesSecuritePage />} />
          </Route>
          <Route path="documents" element={<Navigate to="/admin/shotokan-black-dragon/documents-preuves/documents" replace />} />
          <Route path="dossiers-preuves" element={<Navigate to="/admin/shotokan-black-dragon/documents-preuves/dossiers" replace />} />
          <Route path="journal-validation" element={<Navigate to="/admin/shotokan-black-dragon/documents-preuves/journal" replace />} />
        </Route>
        <Route path="admin/titres" element={<Navigate to="/admin/shotokan-black-dragon/titres" replace />} />
        <Route path="admin/demandes-titres" element={<Navigate to="/admin/shotokan-black-dragon/demandes" replace />} />
        <Route path="admin/reconnaissances" element={<Navigate to="/admin/shotokan-black-dragon/reconnaissances" replace />} />
        <Route path="admin/autorite-titres" element={<Navigate to="/admin/shotokan-black-dragon/autorite" replace />} />
        <Route path="admin/documents-autorite" element={<Navigate to="/admin/documents-preuves/documents" replace />} />
        <Route path="admin/dossiers-preuves" element={<Navigate to="/admin/documents-preuves/dossiers" replace />} />
        <Route path="admin/journal-validation" element={<Navigate to="/admin/documents-preuves/journal" replace />} />
        <Route path="admin/communications" element={<AdminCommunicationsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
